<template>
  <div class="">
    <div class="tableDiv">
      <div class="table-header"><span class="tableheading">ItemView (1-8/8) - PendPR</span> </div>
      <b-table class="requisit" striped hover :items="items" :fields="fields" selectable
      @row-selected="onRowSelected">
      <template slot="selected">
        <img src="img/docimg.gif" />
    </template>
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <a-checkbox :checked="rowSelected" @change="onChange">
          </a-checkbox>
        </template>
        <template v-else>
          <a-checkbox @change="onChange">
          </a-checkbox>
        </template>
      </template>
      </b-table>
      <span class="page"><span style="color:blue; margin-right: 5px;">1</span> 2</span>
    </div>

<b-modal id="catalog-modal" size="lg" hide-footer>
    <template #modal-title>
      <img class="ielogo" src="img/ielogo.png" /> 
      <strong> HDocument - Microsoft Internet Explorer</strong>
      <div class="toolicons">
      <i @click="$bvModal.hide('catalog-modal')" data-v-056ee09c="" aria-label="icon: underline" class="anticon anticon-underline"><svg viewBox="64 64 896 896" data-icon="underline" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1"></path></svg></i>
      <i data-v-056ee09c="" aria-label="icon: play-square" class="anticon anticon-play-square"><svg viewBox="64 64 896 896" data-icon="play-square" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"></path></svg></i>
      <a-icon type="close" @click="$bvModal.hide('catalog-modal')" />
    </div>
    </template>
    
    <div class="d-block text-center save-filter">
      <div class="tableDiv">
      <div class="table-header" style="text-align: center">
        <span class="tableheading">Product Specifications</span> 
      </div>
      <div class="table-body">
        <h4 style="text-align: left; border: 2px solid #fff; margin-bottom: 0;">Product Details</h4>
        <div class="item-view">
          <div class="item-list">
            <h6 style="background: #fff; padding: 5px;">SAMSUNG Crystal 4K Pro</h6>
            <b-row>
              <b-col sm="4">
                <b-list-group>
                    <h6>Specifications</h6>
                  <b-list-group-item>
                    <span style="color: #1341bb;"><strong>Crystal 4K Resolution</strong></span><br>
                    <span style="color: #2526fe;">108 cm (43 inch)</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span style="color: #1341bb;"><strong>LED</strong></span><br>
                    <span style="color: #2526fe;">Ultra HD (4K), 3840 x 2160</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span style="color: #1341bb;"><strong>Description</strong></span><br>
                    <span style="color: #2526fe;">Mercury 14" Color TV</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span style="color: #1341bb;"><strong>Resolution</strong></span><br>
                    <span style="color: #2526fe;">Ultra HD (4K) 3840 x 2160</span>
                  </b-list-group-item>
                  <b-list-group-item>
                    <span style="color: #1341bb;"><strong>Refresh Rate</strong></span><br>
                    <span style="color: #2526fe;">60 Hz</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col sm="8">
                <div class="product">
                  <img style="width: 90%; padding-top: 15px;" src="img/tv.jpeg" />
                  <p style="text-align: left; padding-left: 15px;">
                    <span><strong>Product Id:</strong> SAMSUNG Crystal 4K Pro</span><br>
                    <span><strong>Company Id:</strong> UA43AUE70AKLXL</span><br>
                    <span><strong>Product Price:</strong> $ 4000</span><br>
                    <span>The SAMSUNG Ultra HD (4K) LED Smart TV (UA55AUE70AKLXL) is a stylish, minimalist, and feature-rich home entertainment appliance.</span><br>
                  </p>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
              <p class="links">
                <a style="text-decoration: none;" href="#">1</a>
                <a href="#">2</a>
                <a href="#">3</a>
                <a href="#">4</a>
                <a href="#">5</a>
              </p>
      </div>
    </div>
    </div>
  </b-modal>

  </div>
</template>

<script>
export default {
  name: 'CatalogItems',
  data() {
      return {
        fields: ['selected', 'Item_Code', 'Item_Description', 'Material', 'Standard', 'Weight', 'Item_Type', 'Item_Category_Code'],
        items: [
          { Item_Code: 'CPU001', Item_Description: 'SAMSUNG Ultra HD (4K) LED Smart TV', Material: 'TV', Standard: '', Weight: '10.000', Item_Type: 'BoughtOut', Item_Category_Code: '001' },
          { Item_Code: 'CPU002', Item_Description: 'SAMSUNG Ultra HD (4K) LED Smart TV', Material: 'TV', Standard: '', Weight: '10.000', Item_Type: 'BoughtOut', Item_Category_Code: '001' },
          { Item_Code: 'KB001', Item_Description: 'SAMSUNG Ultra HD (4K) LED Smart TV', Material: 'TV', Standard: '', Weight: '10.000', Item_Type: 'BoughtOut', Item_Category_Code: '001' },
          { Item_Code: 'KB002', Item_Description: 'SAMSUNG Ultra HD (4K) LED Smart TV', Material: 'TV', Standard: '', Weight: '10.000', Item_Type: 'BoughtOut', Item_Category_Code: '001' },
          { Item_Code: 'KB003', Item_Description: 'SAMSUNG Ultra HD (4K) LED Smart TV', Material: 'TV', Standard: '', Weight: '10.000', Item_Type: 'BoughtOut', Item_Category_Code: '001' },
          { Item_Code: 'KB002', Item_Description: 'SAMSUNG Ultra HD (4K) LED Smart TV', Material: 'TV', Standard: '', Weight: '10.000', Item_Type: 'BoughtOut', Item_Category_Code: '001' },
          { Item_Code: 'PC001', Item_Description: 'SAMSUNG Ultra HD (4K) LED Smart TV', Material: 'TV', Standard: '', Weight: '10.000', Item_Type: 'BoughtOut', Item_Category_Code: '001' },
          { Item_Code: 'PC002', Item_Description: 'SAMSUNG Ultra HD (4K) LED Smart TV', Material: 'TV', Standard: '', Weight: '10.000', Item_Type: 'BoughtOut', Item_Category_Code: '001' },

        ],
        selected: [],
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      }
    },
    methods: {
        onRowSelected(items) {
          this.selected = items
          this.$root.$emit("bv::show::modal", "catalog-modal");
        },
        onChange(e) {
          this.checked = e.target.checked;
        },
      }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item-view{
  background: #aabfe5;
}
.links{
  position: absolute;
  margin-top: 20px;
}
.links a{
  margin-left: 3px;
  color: black
}
.product{
  background: #fff;
    height: 100%;
    border: 2px solid #aabfe5;
}
.item-list{
  margin-left: 25px;
    margin-right: 25px;
    background: #eeebfe;
}
#catalog-modal .tableheading{
  color: #fff;
    letter-spacing: 4px;
    font-weight: 400;
}
#catalog-modal .table-body{
  background: #e8f0f8;
    padding: 10px 30px 60px 30px;
}
#catalog-modal .list-group-item{
  background-color: transparent;
    border-bottom: 2px solid #333;
    text-align: left;
}
#catalog-modal .tableDiv{
  margin: 10px 40px;
}
#catalog-modal .table-body h4{
  color: #2526fe;
    font-weight: 400;
}
.tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
}
.table-header{
  background: #bdc7d6;
  text-align: left;
  border-bottom: 1px solid;
}
.tableimg{
  padding-left: 10px;
    padding-right: 10px;
    width: 30px;
    margin-top: -4px;
}
.tableheading{
  padding-left: 10px;
      font-size: 14px;
    font-weight: 700;
}
.table-body{
      text-align: center;
    padding: 5px;
}
.table-body select, .table-body input{
  border: 2px inset;
}
.page{
  padding-top: 5px !important;
  padding-left: 15px !important;
   font-weight:500;
    font-size: 12px;
}
.ielogo{
  width: 20px;
  margin-left: 5px;
}
.toolicons{
      position: absolute;
      right: 3px;
    top: -2px;
}
.toolicons .anticon{
      background: #c0c0c0;
    border: 2px outset;
    margin-right: 2px;
    color: #333;
}
.green-glass{
  position: relative;
    display: inline-block;
        padding: 0px 15px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(lightgreen,#66b266,lightgreen);
    text-decoration: none;
    color: #333;
    font-size: 14px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
.glass{
position: relative;
    display: inline-block;
    padding: 0px 14px;
    border: 0;
    background-color: green;
    background-image: linear-gradient(#d8e1e9,#c1cfdc,#d8e1e9);
    text-decoration: none;
    color: #333;
    font-size: 15px;
    font-family: sans-serif;
    font-weight: 700;
    box-shadow: rgb(0 0 0 / 25%) 1.95px 1.95px 2.6px;
    border-radius: 15px;
    margin-right: 5px;
    max-width: 135px;
}
select {

  /* styling */
  background-color: white;
  border: thin solid blue;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 0em 3.5em 0em 0.5em;

  /* reset */

  margin: 0;      
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}
select.round {
background-image: linear-gradient( 
45deg, transparent 30%, gray 74%), linear-gradient( 
135deg, gray 68%, transparent 36%), radial-gradient(#c0c0c0 100%, transparent 50%);
    background-position: calc(100% - 12px) calc(1em + -5px), calc(100% - 8px) calc(1em + -5px), calc(100% - 0em) 0em;
    background-size: 5px 5px, 5px 5px, 1.5em 1.5em;
    background-repeat: no-repeat;
    border: 2px inset;
    }
    .view-filter .tableDiv{
  border: 1px solid;
  margin: 20px 0px 15px 5px;
  border-radius: 5px;
  text-align: left;
  min-width: 1200px;
  margin-bottom: 100px;
    padding-bottom: 50px;
}
.filter-btn{
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 30px;
}
.save-filter-btn{
      display: table;
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
}
</style>
